import React from "react";
import { StyleSheet, View, Text } from "react-native-web";
import { useTranslation } from "react-i18next";
import { Colors, Fonts } from "../../../config";
import { BackButton } from "../../../components/atoms";
import { getClass } from "../../../helpers/formatHelpers";

const NavigationView = (props) => {
  const { t } = useTranslation();
  const { isMobileVersion, categoryTitle } = props;
  return (
    <div>
      {isMobileVersion ? (
        <div className="flex flex-row items-center justify-between">
          <BackButton
            onBackPressed={props.onBack}
            isNotAbsolute={true}
            isMobileVersion={isMobileVersion}
          />
          <Text
            style={[
              styles.title,
              {
                fontSize: 16,
              },
            ]}>
            {t("key_title_filter")} {categoryTitle}
          </Text>
          <div className="w-16 h-16" />
        </div>
      ) : (
        <View style={styles.container}>
          <Text style={styles.title}>{t("key_title_filter")}</Text>
          {props.onClear && (
            <Text style={styles.action} onPress={props.onClear}>
              {t("key_web_button_clear_all")}
            </Text>
          )}
        </View>
      )}
    </div>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingTop: 4,
  },
  title: {
    fontFamily: Fonts.primaryBold,
    color: getClass("text-white"),
    fontSize: 20,
  },
  action: {
    fontFamily: Fonts.primaryBold,
    color: Colors.white50,
    textDecorationLine: "underline",
    fontSize: 14,
    cursor: "pointer",
  },
});

export default NavigationView;
